import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import LanguageSelector from './components/LanguageSelector';
import './styles.css';

function App() {
  return (
    <Router>
      <div className="bg-allica-gray min-h-screen flex items-center justify-center p-4 font-sans selection:bg-allica-primary selection:text-white">
        <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-br from-allica-primary to-allica-dark"></div>
        
        <div className="w-full max-w-2xl mx-auto relative z-10">
          {/* Custom top navigation */}
          <div className="flex justify-between items-center mb-6 px-2">
            <div className="text-white flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
              <span className="text-sm">Secure Banking Portal</span>
            </div>
            <div className="text-white flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-sm">Help & Support</span>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl shadow-card overflow-hidden backdrop-blur-sm border border-white/10">
            <div className="p-8 md:p-10">
              {/* Logo */}
              <div className="flex justify-center mb-10">
                <a href="/" className="inline-block">
                  <img className="h-12" src="/images/logo.png" alt="ALLICA BANK logo" />
                </a>
              </div>
              
              {/* Heading */}
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-allica-dark mb-3">Welcome Back</h3>
                <div className="flex items-center justify-center mb-2">
                  <div className="w-16 h-1 bg-allica-secondary rounded-full"></div>
                </div>
                <p className="text-gray-600 max-w-md mx-auto">Access your SWIFT WAVE account securely with your credentials</p>
              </div>
              
              {/* Custom tabs */}
              <div className="flex justify-center mb-8">
                <div className="flex space-x-6 border-b border-gray-200 w-full max-w-xs">
                  <button className="pb-2 relative text-allica-primary font-medium flex-1 text-center">
                    Personal
                    <div className="absolute bottom-0 left-0 w-full h-0.5 bg-allica-primary rounded-full"></div>
                  </button>
                  <button className="pb-2 text-gray-400 font-medium flex-1 text-center hover:text-gray-600 transition-colors">Business</button>
                </div>
              </div>
              
              <Routes>
                <Route path="/" element={<LoginForm />} />
                {/* Add other routes as needed */}
              </Routes>
              
              {/* Footer */}
              <div className="mt-12 pt-6 border-t border-gray-200">
                <div className="flex justify-center">
                  <LanguageSelector />
                </div>
                <div className="mt-6 text-center text-sm text-gray-500 flex items-center justify-center space-x-4">
                  <a href="#" className="hover:text-allica-primary transition-colors">Privacy Policy</a>
                  <span className="text-gray-300">|</span>
                  <a href="#" className="hover:text-allica-primary transition-colors">Terms of Service</a>
                  <span className="text-gray-300">|</span>
                  <a href="#" className="hover:text-allica-primary transition-colors">Help</a>
                </div>
                <div className="mt-4 text-center text-sm text-gray-500">
                  <p>&copy; 2024 SWIFTWAVE. All Rights Reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
